import { render } from "./SemAcesso.vue?vue&type=template&id=2823cf90&scoped=true"
import script from "./SemAcesso.vue?vue&type=script&lang=js"
export * from "./SemAcesso.vue?vue&type=script&lang=js"

import "./SemAcesso.vue?vue&type=style&index=0&id=2823cf90&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2823cf90"]])

export default __exports__